import styled from "styled-components";
import Rectangle from "../../images/Rectangle.svg";
import Company from "../../images/Company.svg";

export const MainDiv = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;

  .left_container {
    width: 50%;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 400px;
      height: 211px;
      display: flex;
      flex-direction: column;
      gap:20px;
      .head1 {
        width: 400px;
        height: 40px;
        font-size: 20px;
        font-weight: 700;
        line-height: 25.82px;
        color: #1e2228;
        margin-bottom: 20px;
      }

      .otp_container {
        display: flex;
        flex-direction:row;
        margin-bottom: 20px;
        gap:10px;
        .otp_input {
          width: 50px;
          height: 50px;
          font-size: 20px;
          text-align: center;
          border: 1px solid #ccc;
          border-radius: 5px;
        }
      }

      & button {
        display: flex;
        height:40px;
        width:121px;
        padding: 10px 20px;
        font-size: 16px;
        font-weight: 700;
        background-color:#ff2c91;

        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }

  .right_container {
    width: 50%;
    background-image: url(${Rectangle});
    background-size: cover;
    background-position: center;

    display: flex;
    justify-content: center;
    align-items: center;

    div {
      background-image: url(${Company});
      background-size: contain;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 488.1px;
      height: 269px;
    }
  }
`;
